module.exports = __webpack_public_path__ + "img/bg-stars.f4553689.svg";